export const Comparacion = ({ name, value, onChange }) => {
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='R'>Real</option>
            <option value='P'>Proyectado</option>
        </select>
    )
}